import {
    Icon,
    useAccordionItemState,
    useAccordionContext,
} from '@chakra-ui/react';

/**
 * CustomAccordionIcon is a custom icon component for the Accordion component in Chakra UI.
 * @typedef {Object} CustomAccordionIconProps
 * @param {import('@chakra-ui/react').IconProps} props - The props for the accordion icon component.
 * */
export default function CustomAccordionIcon(props) {
    const { isOpen, isDisabled } = useAccordionItemState();
    const { reduceMotion } = useAccordionContext();

    return (
        <Icon
            viewBox="0 0 24 24"
            aria-hidden
            __css={{
                opacity: isDisabled ? 0.4 : 1,
                transform: isOpen ? 'rotate(0deg)' : 'rotate(-90deg)',
                transition: reduceMotion ? undefined : 'transform 0.2s',
                transformOrigin: 'center',
            }}
            {...props}>
            <path
                fill="currentColor"
                d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"
            />
        </Icon>
    );
}
